import React, { useImperativeHandle, useState } from "react"
import { ModalHeader, ModalBody, ModalFooter, Button, Form, FormFeedback } from "reactstrap"
import { useSelector } from 'react-redux'
import { useForm } from "react-hook-form"
import classnames from "classnames"
import { trans } from '@utils'
import { ButtonSpinner } from '@src/components'
import InputContainer from "@src/components/helpers/InputContainer"
import CustomFormGroup from "@src/components/helpers/CustomFormGroup"
import ModalWrapper from "@src/components/ModalWrapper"

const QueryModal = React.forwardRef((props, ref) => {
	const loading = useSelector(store => store.app.loading)
	//************************************//
	const { handleSubmit, errors, control } = useForm({})
	//************************************//
	const [modal, setModal] = useState({ open: false, data: {}, isEdit: false })
	//************************************//
	const _open = (args) => {
		const data = args?.data || {}
		const isEdit = args?.isEdit || false
		setModal((modal) => ({ open: true, data, isEdit }))
	}
	const _close = () => {
		setModal((modal) => ({ ...modal, open: false }))
		if (props.onClose) props.onClose()
	}
	//************************************//
	const onSubmit = async ({ name }) => {
		if (props.onChange) {
			props.onChange({ key: _.get(modal.data, 'key', ''), name }, _close)
		}
	}
	//************************************//
	useImperativeHandle(ref, () => ({
		open: _open,
		close: _close
	}))
	return (
		<ModalWrapper
			scrollable={false}
			isOpen={modal.open}
			toggle={_close}
			unmountOnClose={true}
			backdrop={true}
			className='modal-md'
			modalClassName={''}
			showLoader={false}
			autoFocus={false}
			title={modal.isEdit ? trans("gen.datatable.renameQuery") : trans("gen.datatable.addQuery")}
		>
			<Form onSubmit={handleSubmit(onSubmit)}>
				<ModalHeader toggle={_close}>
					{modal.isEdit ? trans("gen.datatable.renameQuery") : trans("gen.datatable.addQuery")}
				</ModalHeader>
				<ModalBody>
					<CustomFormGroup title={trans('gen.name')}>
						<InputContainer
							type={'text'}
							name={'name'}
							control={control}
							className={classnames({ 'is-invalid': _.get(errors, `name.message`) })}
							defaultValue={_.get(modal.data, 'name', '')}
							autoFocus={true}
							rules={{
								required: trans('gen.validations.required'),
								validate: {
									maxLength: (value) => {
										return _.size(value) <= 125 || trans('gen.validations.maxlength', { maxlength: 125 })
									}
								}
							}}
							data-1p-ignore
						/>
						{_.get(errors, `name`) && <FormFeedback> {_.get(errors, `name.message`)} </FormFeedback>}
					</CustomFormGroup>
				</ModalBody>
				<ModalFooter>
					<Button color={'flat-secondary'} type='button' onClick={_close}>
						{trans('gen.actions.cancel')}
					</Button>
					<Button color={'primary'} type='submit' disabled={loading}>
						{loading ? <ButtonSpinner /> : null}
						{trans('gen.actions.save')}
					</Button>
				</ModalFooter>
			</Form>
		</ModalWrapper>
	)
})

QueryModal.propTypes = {

}

export default QueryModal